// eslint-disable-next-line max-len
var USER_INTERFACE_CIRCLE_CROSS_CANCEL = 'M21.71,11.71,17.41,16l4.3,4.29a1,1,0,0,1-1.42,1.42L16,17.41l-4.29,4.3a1,1,0,0,1-1.42-1.42L14.59,16l-4.3-4.29a1,1,0,0,1,1.42-1.42L16,14.59l4.29-4.3a1,1,0,0,1,1.42,1.42ZM32,16A16,16,0,1,1,16,0,16,16,0,0,1,32,16Zm-2,0a14,14,0,1,0-4.1,9.9A14,14,0,0,0,30,16Z';

export { USER_INTERFACE_CIRCLE_CROSS_CANCEL };
//# sourceMappingURL=USER_INTERFACE_CIRCLE_CROSS_CANCEL.js.map
